<div class="errwrap">
  <div class="errdiv1" id="errs"></div>
</div>

<div class="searchdiv">
  <app-shared-header-div *ngIf="actionmode == 'Add' || actionmode == 'Edit'" [screentitle]="screentitle"
    [headerDivName]="headerDivName" [actionmode]="actionmode" (submitDataOne)="submitData($event)"
    (search_Form)="searchForm($event)">
  </app-shared-header-div>
  <div *ngIf="actionmode != 'Add' && actionmode != 'Edit'" class="headerdiv">
    <h1>Fare Family Search</h1>
    <div class="bothbuttdiv">
      <button class="btn btn-primary commonbutt" type="button" (click)="addForm()">
        <em class="fa fa-plus-circle"></em>&nbsp;Add New
      </button>
    </div>
  </div>
  <div class="card-body">
    <div class="row">
      <div class="col-md-12">
        <div class="form-div">
          <div class="row">
            <div class="m-portlet">
              <div>
                <div>
                  <div>
                    <div>
                      <div class="col-lg-3">
                        <label class="">TPM From</label>
                        <input [(ngModel)]="screen_details.from" class="form-control m-input" />
                      </div>

                      <div class="col-lg-3">
                        <label class="">TPM To</label>
                        <input [(ngModel)]="screen_details.to" class="form-control m-input" />
                      </div>

                      <div class="clr"></div>
                      <div class="divider"></div>
                      <br />
                      <div class="col-lg-3">
                        <label class="">ECO</label>
                        <input [(ngModel)]="screen_details.eco" class="form-control m-input" />
                      </div>

                      <div class="col-lg-3">
                        <label class="">PRE</label>
                        <input [(ngModel)]="screen_details.pre" class="form-control m-input" />
                      </div>

                      <div class="col-lg-3">
                        <label class="">Flight Type</label>

                        <select name="COUNTRY_CODE" class="form-control" [(ngModel)]="screen_details.flight"
                          [disabled]="showList == true">
                          <option disabled value="0">Select Flight Type</option>

                          <option value="D"> D</option>
                          <option value="I"> I</option>
                        </select>
                      </div>
                    </div>

                    <div class="btn clear-button button-margin">
                      <div>
                        <button *ngIf="actionmode != 'Add' && actionmode != 'Edit'" style="margin-top: 20px;"
                          class="btn btn-primary commonbutt" (click)="searchData()" type="button">
                          <em class="fa fa-search "></em>&nbsp;Search
                        </button>
                      </div>
                    </div>

                    <div *ngIf="searchresult && actionmode != 'Add' && actionmode != 'Edit'" class="reportstatus"
                      [hidden]="searchlist">
                      <table aria-describedby="fareFamilySearchDetails" class="table table-striped" *ngIf="!loader"
                        [mfData]="serachtabledata" [mfRowsOnPage]="5">
                        <thead>
                          <tr>
                            <th scope="col" style="width: 20%">
                              <mfDefaultSorter by="name">Action</mfDefaultSorter>
                            </th>
                            <th scope="col" style="width: 20%">
                              <mfDefaultSorter by="name">TPM From</mfDefaultSorter>
                            </th>
                            <th scope="col" style="width: 20%">
                              <mfDefaultSorter by="email">
                                TPM To</mfDefaultSorter>
                            </th>
                            <th scope="col" style="width: 20%">
                              <mfDefaultSorter by="email">ECO</mfDefaultSorter>
                            </th>
                            <th scope="col" style="width: 10%">
                              <mfDefaultSorter by="email">PRE</mfDefaultSorter>
                            </th>
                            <th scope="col" style="width: 20%">
                              <mfDefaultSorter>Flight Type</mfDefaultSorter>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="
                              let item of (serachtabledata
                                | paginate
                                  : { itemsPerPage: 10, currentPage: p })
                            ">
                            <td>
                              <button class="btn btn-default btn-circle" type="button" (click)="showFormData(item, 2)">
                                <em class="fa fa-pencil"></em>
                              </button>
                            </td>
                            <td>{{ item.tpm_from }}</td>
                            <td>{{ item.tpm_to }}</td>
                            <td>
                              {{ item.eco }}
                            </td>
                            <td>
                              {{ item.pre }}
                            </td>
                            <td>
                              {{ item.flight_type }}
                            </td>
                          </tr>
                        </tbody>

                        <tfoot>
                          <tr>
                            <td colspan="6">
                              <pagination-controls (pageChange)="p = $event"></pagination-controls>
                            </td>
                          </tr>
                        </tfoot>
                      </table>
                    </div>

                    <br />

                    <div *ngIf="searchresult" class="reportstatus" [hidden]="searchlist"></div>
                    <div *ngIf="loader">
                      <div style="margin:auto; text-align: center">
                        <img src="../../../../assets/img/Loading_Animation.gif" width="8%" height="8%" alt="Loader" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>